module.exports = __webpack_public_path__ + "img/planning-center.edd112f7.svg";